"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledCircleContent = exports.StyledCircle = void 0;
var styled_components_1 = __importDefault(require("styled-components"));
var storm_ui_1 = require("@amzn/storm-ui");
exports.StyledCircle = (0, styled_components_1.default)('span')(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  color: ", ";\n  .fa-circle path {\n    stroke: ", ";\n    stroke-width: ", ";\n    stroke-linejoin: round;\n  }\n"], ["\n  color: ", ";\n  .fa-circle path {\n    stroke: ", ";\n    stroke-width: ", ";\n    stroke-linejoin: round;\n  }\n"])), function (_a) {
    var backgroundColor = _a.backgroundColor;
    return backgroundColor;
}, function (_a) {
    var borderColor = _a.borderColor;
    return borderColor !== null && borderColor !== void 0 ? borderColor : 'none';
}, function (_a) {
    var borderSize = _a.borderSize;
    return borderSize !== null && borderSize !== void 0 ? borderSize : 'none';
});
exports.StyledCircleContent = (0, styled_components_1.default)('span')(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  color: ", ";\n  font-weight: ", ";\n"], ["\n  color: ", ";\n  font-weight: ", ";\n"])), function (_a) {
    var circleContentColor = _a.circleContentColor;
    return circleContentColor !== null && circleContentColor !== void 0 ? circleContentColor : storm_ui_1.defaultTheme.palette.black;
}, function (_a) {
    var circleContentColor = _a.circleContentColor;
    return circleContentColor !== null && circleContentColor !== void 0 ? circleContentColor : 'none';
});
var templateObject_1, templateObject_2;
